import { render, staticRenderFns } from "./DrawerItem.vue?vue&type=template&id=3220ca23&"
import script from "./DrawerItem.vue?vue&type=script&lang=js&"
export * from "./DrawerItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports